import { FC } from 'react';
import DOMPurify from 'dompurify';

interface HtmlContentProps {
    content: string;
    allowedTags?: string[];
    allowedAttributes?: string[];
}

export const HtmlContent: FC<HtmlContentProps> = ({
    content,
    allowedTags = [
        'a',
        'i',
        'b',
        'p',
        'strong',
        'sup',
        'ul',
        'li',
        'ol',
        'br',
        'hr',
        'img',
        'svg',
        'title',
        'desc',
        'defs',
        'g',
        'path',
    ],
    allowedAttributes = [
        'href',
        'target',
        'src',
        'style',
        'width',
        'height',
        'viewBox',
        'version',
        'xmlns',
        'xmlns:xlink',
        'id',
        'transform',
        'fill',
        'fill-rule',
        'stroke',
        'stroke-width',
        'd',
    ],
}) => {
    const sanitizedHtml = DOMPurify.sanitize(content, {
        /* eslint-disable @typescript-eslint/naming-convention */
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: allowedAttributes,
        /* eslint-enable @typescript-eslint/naming-convention */
    });

    // eslint-disable-next-line @typescript-eslint/naming-convention
    return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};
